export enum SourceSheet {
  RawDataSummary,
  PaymentExtract,
  BucketReport,
  HistoryByReturn,
  HistoryByState,
  CreditData,
  ReturnsCalendar,
  AnybillReturns,
  PaymentsMetadata,
  CreditCarryForward,
  TaxColNotRegistered,
  Recon,
}

export type SheetTableInfo = {
  sheetName: string;
  tableName: string;
  shouldRefreshStatus?: boolean;
  shouldProtect?: boolean;
};

const INPUT_DATA_SHEET_TABLES: Record<SourceSheet, SheetTableInfo> = {
  [SourceSheet.RawDataSummary]: { sheetName: 'Translated Data', tableName: 'TranslatedData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.PaymentExtract]: { sheetName: 'Payment Extract', tableName: 'PaymentExtractData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.BucketReport]: { sheetName: 'Bucket Report', tableName: 'BucketReportData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.HistoryByReturn]: { sheetName: 'History by Return', tableName: 'HistoryByReturnData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.HistoryByState]: { sheetName: 'History by State', tableName: 'HistoryByStateData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.CreditData]: { sheetName: 'Credit Data', tableName: 'Credit_Data', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.ReturnsCalendar]: { sheetName: 'Returns Calendar', tableName: 'ReturnCalendarData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.AnybillReturns]: { sheetName: 'Anybill Table', tableName: 'AnybillReturnsData' },
  [SourceSheet.PaymentsMetadata]: { sheetName: 'Payments Metadata', tableName: 'PaymentsMetadata' },
  [SourceSheet.CreditCarryForward]: { sheetName: 'Credit Carry Forward', tableName: 'CreditCFData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.TaxColNotRegistered]: { sheetName: 'Tax Col Not Registered', tableName: 'TCNRData', shouldRefreshStatus: true, shouldProtect: true },
  [SourceSheet.Recon]: { sheetName: 'Recon', tableName: 'ReconTable', shouldRefreshStatus: true, shouldProtect: true },
};

export function getTableConfig(sheet: SourceSheet): SheetTableInfo {
  return INPUT_DATA_SHEET_TABLES[sheet];
}

export function getAllInputSheetTableNames(): SheetTableInfo[] {
  return Object.values(INPUT_DATA_SHEET_TABLES);
}

export function getInputSheetNames(): string[] {
  return getAllInputSheetTableNames().map((s) => s.sheetName)
}

export function getInputSheetNamesToProtect(): string[] {
  return getAllInputSheetTableNames()
    .filter((sheet) => sheet.shouldProtect)
    .map((s) => s.sheetName)
}